'use client';
import { MaskedInput } from '@curology/ui-components-web/react/MaskedInput';
import React, { useState } from 'react';

import { type Brand } from '@/consts/brands';
import { type TreatmentCategory } from '@/consts/treatmentCategories';
import { useTrackFieldEvent } from '@/utils/metrics';

import { FORM_CONFIG } from '../config';
import { isBirthdateValid, updateEligibilityData } from '../utils/helpers';

export const BirthdateInput = ({
  birthdate,
  setBirthdate,
  state,
  brand,
  treatmentCategory,
}: {
  birthdate?: string;
  setBirthdate: (value: string) => void;
  state: string;
  brand: Brand;
  treatmentCategory?: TreatmentCategory;
}) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  // TODO: Remove hook once Feature Flag package has global tracking helper
  const { trackFieldEntered, trackFieldFocused } = useTrackFieldEvent();

  return (
    <div>
      <MaskedInput
        autoComplete={FORM_CONFIG.birthdate.autoComplete}
        className="cur-pt-2 cur-px-2"
        enterKeyHint="next"
        helperText={errorMessage}
        id={FORM_CONFIG.birthdate.name}
        label={FORM_CONFIG.birthdate.label}
        mask={[/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        name={FORM_CONFIG.birthdate.name}
        onBlur={(event) => {
          const value = event.target.value;

          setBirthdate(value);

          setErrorMessage(
            !isBirthdateValid(value)
              ? 'The patient’s date of birth is not valid.'
              : undefined,
          );

          trackFieldEntered(
            FORM_CONFIG.birthdate.shortName,
            2,
            value.length.toString(),
          );

          updateEligibilityData(brand, {
            birthdate: value,
            state,
            treatmentCategories: treatmentCategory,
          });
        }}
        onChange={(event) => setBirthdate(event.target.value)}
        onFocus={() => trackFieldFocused(FORM_CONFIG.birthdate.shortName, 2)}
        placeholder="mm/dd/yyyy"
        state={errorMessage ? 'critical' : ''}
        type="text"
        value={birthdate}
      />
    </div>
  );
};

export default BirthdateInput;
